var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfileUserSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "none",
    x: "0px",
    y: "0px",
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    fill: "none",
    d: " M 4.75 7.8 L 4.75 3.65 Q 4.75 3.2 5.05 2.9 5.35 2.6 5.8 2.6 L 20.35 2.6 Q 20.8 2.6 21.1 2.9 21.4 3.2 21.4 3.65 L 21.4 22.4 Q 21.4 22.85 21.1 23.15 20.8 23.45 20.35 23.45 L 5.8 23.45 Q 5.35 23.45 5.05 23.15 4.75 22.85 4.75 22.4 L 4.75 18.25 4.75 13 4.75 7.8 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: " M 2.65 18.25 L 4.75 18.25 M 2.65 7.8 L 4.75 7.8 6.8 7.8 M 4.75 18.25 L 6.8 18.25 M 2.65 13 L 4.75 13 6.8 13 M 17.25 3.65 L 17.25 22.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileUserSummary);
export default __webpack_public_path__ + "static/media/icon-profile-user-summary.55e0ed7f5d6fec0e98d89a000bf36b1b.svg";
export { ForwardRef as ReactComponent };